import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { orderFragment } from '#src/lib/order/fragments/order-fragment';
import { query as orderQuery } from '#src/hooks/use-order-query';

const query = gql`
  mutation resumeOrder($id: Int!, $userId: Int!) {
    resumeOrderV2(id: $id, processorVersion: V2, userId: $userId) {
      ...OrderFragment
    }
  }

  ${orderFragment}
`;

export function useResumeOrderMutation({ order, orderId, userId }) {
  const [resumeOrder, { loading, error }] = useMutation(query, {
    variables: { id: orderId, userId },
    update(store, { data: { resumeOrderV2 } }) {
      store.writeQuery({
        query: orderQuery,
        data: { order: resumeOrderV2 },
        variables: { orderId },
      });
    },
  });

  useEffect(() => {
    if (order && order.processorVersion === 'APPLEIAP') resumeOrder();
  }, [resumeOrder, order]);

  return { loading, error };
}
